// @ts-strict-ignore
import {AfterViewInit, Component, Input, OnInit, output} from "@angular/core";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {
	animate,
	animateChild,
	animation,
	group,
	keyframes,
	query,
	state,
	style,
	transition,
	trigger,
	useAnimation,
} from "@angular/animations";
import {IAnimationOptions} from "angular-animations/common/interfaces";

const zoomIn = () =>
	animation(
		group([
			animate(
				"{{duration}}ms {{delay}}ms",
				keyframes([
					style({opacity: 0, easing: "ease", offset: 0}),
					style({opacity: 1, easing: "ease", offset: 0.5}),
					style({opacity: 1, easing: "ease", offset: 1}),
				]),
			),
			animate(
				"{{duration}}ms {{delay}}ms",
				keyframes([
					style({
						visibility: "visible",
						transform: "scale3d(0.3, 0.3, 0.3)",
						easing: "ease",
						offset: 0,
					}),
					style({
						transform: "scale3d(1, 1, 1)",
						easing: "ease",
						offset: 1,
					}),
				]),
			),
		]),
	);

export function useAnimationIncludingChildrenCustom(animation, options) {
	return [
		...(options && options.animateChildren === "before" ? [query("@*", animateChild(), {optional: true})] : []),
		group([
			useAnimation(animation),
			...(!options || !options.animateChildren || options.animateChildren === "together"
				? [query("@*", animateChild(), {optional: true})]
				: []),
		]),
		...(options && options.animateChildren === "after" ? [query("@*", animateChild(), {optional: true})] : []),
	];
}

const zoomInOptions: IAnimationOptions = {
	duration: 175,
	delay: 0,
};

@Component({
	selector: "sim-admin-settings-slider-to-editable-slider",
	templateUrl: "./sim-admin-settings-slider-to-editable-slider.component.html",
	styleUrls: ["./sim-admin-settings-slider-to-editable-slider.component.scss"],
	animations: [
		zoomInOnEnterAnimation({duration: 175}),
		zoomOutOnLeaveAnimation({duration: 175}),
		trigger("flyInOut", [
			state("in", style({transform: "translateX(0)"})),
			transition("void => *", [style({visibility: "hidden"}), ...useAnimationIncludingChildrenCustom(zoomIn(), zoomInOptions)], {
				params: {
					delay: (zoomInOptions && zoomInOptions.delay) || 0,
					duration: zoomInOptions && zoomInOptions.duration,
				},
			}),
			transition("* => void", [animate(0, style({transform: "translateX(100%)"}))]),
		]),
	],
	standalone: false,
})
export class SimAdminSettingsSliderToEditableSliderComponent implements OnInit, AfterViewInit {
	@Input() value: number;
	@Input() editable: boolean = false;
	@Input() max: number = 10;
	@Input() min: number = 0;
	@Input() step: number = 1;

	onValueChanged = output<number>();

	load_completed: boolean = false;

	constructor() {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.load_completed = true;
	}
}
